/* istanbul ignore file */

import { createRoot } from "react-dom/client";

import { newrelic } from "@jti/fe-clients";

import { getAemModel, StandardCheckoutApp } from "@jti/checkout/aem-standard-checkout";

import "@jti/ui/styles/base.scss";

console.info(`<%= ${process.env.SNAPSHOT_INFO} %>`);

newrelic.addRelease("checkout", `${process.env.NEW_RELIC_VERSION}`);

const container = document.getElementById("aem-checkout");

if (container) {
  const aemModel = getAemModel(container);
  const root = createRoot(container);

  root.render(<StandardCheckoutApp aemModel={aemModel} />);
}
